import {
    DELETE_JOB_OFFER,
    DELETE_JOB_OFFER_SUCCESS, FIND_TALENT_APPLICATION, FIND_TALENT_APPLICATION_SUCCESS,
    GET_JOB_OFFER,
    GET_JOB_OFFER_SUCCESS,
    GET_JOB_OFFERS,
    GET_JOB_OFFERS_API , 
    GET_JOB_OFFERS_SUCCESS,
    UPDATE_APPLICATION_TIME,
    UPDATE_APPLICATION_TIME_SUCCESS,
    UPSERT_JOB_OFFER,
    UPSERT_JOB_OFFER_SUCCESS,
    UPDATE_APPLICATION_FLOW,
    UPDATE_APPLICATION_FLOW_SUCCESS,
    JOB_OFFER_FICHE,
    JOB_OFFER_FICHE_SUCCESS,
    GET_JOB_OFFERS_COUNT,
    GET_JOB_OFFERS_COUNT_SUCCESS,
    JOB_OFFER_PROPOSAL,
    JOB_OFFER_PROPOSAL_SUCCESS,
    JOB_OFFER_CONTRACT,
    JOB_OFFER_CONTRACT_SUCCESS,
    JOB_OFFER_CONTRACT_SIGN,
    JOB_OFFER_CONTRACT_SIGN_SUCCESS,
    JUST_JOB_OFFER_PROPOSAL,
    JOB_OFFER_CONTRACT_PROPOSAL,
    JOB_OFFER_CONTRACT_PROPOSAL_SUCCESS,
    JOB_OFFER_CONTRACT_END,
    JOB_OFFER_CONTRACT_END_SUCCESS,
    DELETE_JOB_OFFER_API,
    GET_TALENTS_BY_JOB_OFFER_REQUEST,
    GET_TALENTS_BY_JOB_OFFER_SUCCESS,
    GET_TALENTS_BY_JOB_OFFER_FAILURE,
    SEND_JOB_OFFER_LINK_REQUEST,
    SEND_JOB_OFFER_LINK_SUCCESS,
    SEND_JOB_OFFER_LINK_FAILURE,
    GET_JOB_OFFERS_LIST_REQUEST,
    GET_JOB_OFFERS_LIST_SUCCESS,
    GET_JOB_OFFERS_LIST_FAILURE,
    GET_HISTORY_TALENT_REQUEST,
    GET_HISTORY_TALENT_SUCCESS,
    GET_HISTORY_TALENT_FAILURE,
    JOB_OFFER_INTERVIEW_JOINED,
    JOB_OFFER_INTERVIEW_JOINED_SUCCESS,
    REMIND_TALENT_LATE_REQUEST,
    REMIND_TALENT_LATE_SUCCESS,
    REMIND_TALENT_LATE_FAILURE,
    CANCEL_OTHER_INTERVIEWS,
    CANCEL_OTHER_INTERVIEWS_SUCCESS,
    FETCH_SHARED_JOB_OFFERS_REQUEST,
    FETCH_SHARED_JOB_OFFERS_SUCCESS,
    FETCH_SHARED_JOB_OFFERS_FAILURE,
    RESEND_JOB_OFFER_LINK_REQUEST,
    RESEND_JOB_OFFER_LINK_SUCCESS,
    RESEND_JOB_OFFER_LINK_FAILURE,
    SHOW_GUIDE_COLLABORATION,
    FETCH_JOB_OFFER_PREVIEW_START,
    FETCH_JOB_OFFER_PREVIEW_SUCCESS,
    FETCH_JOB_OFFER_PREVIEW_ERROR,
    SEARCH_JOB_OFFERS,
    SEARCH_JOB_OFFERS_SUCCESS,
    SEARCH_JOB_OFFERS_COUNT,
    SEARCH_JOB_OFFERS_COUNT_SUCCESS
} from '../action-types'

export const fetchSharedJobOffersRequest = (token) => ({
  type: FETCH_SHARED_JOB_OFFERS_REQUEST,
  payload: token
});

export const fetchSharedJobOffersSuccess = (data) => ({
  type: FETCH_SHARED_JOB_OFFERS_SUCCESS,
  payload: data,
});

export const fetchSharedJobOffersFailure = (error) => ({
  type: FETCH_SHARED_JOB_OFFERS_FAILURE,
  payload: error,
});

export const remindTalentLateRequest = (token, id, intl) => ({
    type: REMIND_TALENT_LATE_REQUEST,
    payload: { token, id, intl },
  });
  
  export const remindTalentLateSuccess = (message) => ({
    type: REMIND_TALENT_LATE_SUCCESS,
    payload: message,
  });
  
  export const remindTalentLateFailure = (error) => ({
    type: REMIND_TALENT_LATE_FAILURE,
    payload: error,
  });

export const sendJobOfferLinkRequest = (token, emails, id, intl) => ({
    type: SEND_JOB_OFFER_LINK_REQUEST,
    payload: { token,emails, id, intl },
});

export const sendJobOfferLinkSuccess = () => ({
    type: SEND_JOB_OFFER_LINK_SUCCESS,
});

export const sendJobOfferLinkFailure = (error) => ({
    type: SEND_JOB_OFFER_LINK_FAILURE,
    payload: error,
});

export const getHistoryTalentRequest = (id, token, intl) => ({
    type: GET_HISTORY_TALENT_REQUEST,
    payload: { id, token, intl },
});

export const getHistoryTalentSuccess = (historyData) => ({
    type: GET_HISTORY_TALENT_SUCCESS,
    payload: historyData,
});

export const getHistoryTalentFailure = (error) => ({
    type: GET_HISTORY_TALENT_FAILURE,
    payload: error,
});


export const getJobOffersListRequest = (token) => ({
    type: GET_JOB_OFFERS_LIST_REQUEST,
    payload: { token },
});

export const getJobOffersListSuccess = (jobOffers) => ({
    type: GET_JOB_OFFERS_LIST_SUCCESS,
    payload: jobOffers,
});

export const getJobOffersListFailure = (error) => ({
    type: GET_JOB_OFFERS_LIST_FAILURE,
    payload: error,
});

export const getTalentsByJobOfferRequest = (job_offer_application_id, page = null, query = null, token, application_id = null) => ({
    type: GET_TALENTS_BY_JOB_OFFER_REQUEST,
    payload: { job_offer_application_id, page, query, token, application_id },
});

export const getTalentsByJobOfferSuccess = (data, paginatorInfo, countStatus,jobOffer) => ({
    type: GET_TALENTS_BY_JOB_OFFER_SUCCESS,
    payload: { data, paginatorInfo, countStatus,jobOffer },
});

export const getTalentsByJobOfferFailure = (error) => ({
    type: GET_TALENTS_BY_JOB_OFFER_FAILURE,
    payload: error,
});

export const getJobOffers = (token, query) => {
    return {
        type: GET_JOB_OFFERS,
        token: token,
        query: query
    }
}

export const getJobOffersApi = (token, query) => {
    return {
        type: GET_JOB_OFFERS_API,
        token: token,
        query: query
    }
}

export const getJobOffersSuccess = (data) => {
    return {
        type: GET_JOB_OFFERS_SUCCESS,
        data: data?.data,
    }
}

export const getJobOffersCount = (token, query) => {
    return {
        type: GET_JOB_OFFERS_COUNT,
        token: token,
        query: query
    }
}

export const getJobOffersCountSuccess = (data) => {
    return {
        type: GET_JOB_OFFERS_COUNT_SUCCESS,
        data: data?.data,
    }
}

export const jobOfferFiche = (token, query, isToast, intl, isToastJobOfferGenerate) => {
    return {
        type: JOB_OFFER_FICHE,
        token: token,
        query: query,
        isToast: isToast,
        intl: intl,
        isToastJobOfferGenerate: isToastJobOfferGenerate,
    }
}

export const jobOfferFicheSuccess = (data) => {
    return {
        type: JOB_OFFER_FICHE_SUCCESS,
        data: data,
    }
}
export const getJobOffer = (token, query, intl) => {
    return {
        type: GET_JOB_OFFER,
        token: token,
        query: query,
        intl: intl
    }
}

export const getJobOfferSuccess = (data) => {
    return {
        type: GET_JOB_OFFER_SUCCESS,
        data: data?.data,
    }
}

export const deleteJobOffer = (token, id, query) => {
    return {
        type: DELETE_JOB_OFFER,
        token: token,
        id: id,
        query: query,
    }
}

export const deleteJobOfferApi = (token, id, query) => {
    return {
        type: DELETE_JOB_OFFER_API,
        token: token,
        id: id,
        query: query,
    }
}


export const deleteJobOfferSuccess = (data) => {
    return {
        type: DELETE_JOB_OFFER_SUCCESS,
        data: data,
    }
}

export const upsertJobOffer = (token, query,intl) => {
    return {
        type: UPSERT_JOB_OFFER,
        token: token,
        query: query,
        intl: intl
    }
}

export const upsertJobOfferSuccess = (data) => {
    return {
        type: UPSERT_JOB_OFFER_SUCCESS,
        data: data,
    }
}

export const updateApplicationTime = (token, id, status, intl) => {
    return {
        type: UPDATE_APPLICATION_TIME,
        token: token,
        id: id,
        status: status,
        intl: intl
    }
}

export const updateApplicationTimeSuccess = (data) => {
    return {
        type: UPDATE_APPLICATION_TIME_SUCCESS,
        data: data,
    }
}

export const findTalentApplication =  (token, talentID) => {
    return {
        type: FIND_TALENT_APPLICATION,
        token: token,
        talentID: talentID
    }
}

export const findTalentApplicationSuccess = (data) => {
    return {
        type: FIND_TALENT_APPLICATION_SUCCESS,
        data: data,
    }
}

export const updateApplicationFlow = (token, formData, intl, typeMes) => {
    return {
        type: UPDATE_APPLICATION_FLOW,
        token: token,
        formData: formData,
        intl: intl,
        typeMes: typeMes
    }
}

export const updateApplicationFlowSuccess = (data) => {
    return {
        type: UPDATE_APPLICATION_FLOW_SUCCESS,
        data: data,
    }
}

export const getJobOfferProposal = (token) => {
    return {
        type: JOB_OFFER_PROPOSAL,
        token: token
    }
}

export const getJobOfferProposalSuccess = (data) => {
    return {
        type: JOB_OFFER_PROPOSAL_SUCCESS,
        data: data,
    }
}

export const getJobOfferContract = (token, id, intl) => {
    return {
        type: JOB_OFFER_CONTRACT,
        token: token,
        id: id,
        intl: intl
    }
}

export const getJobOfferContractSuccess = (data) => {
    return {
        type: JOB_OFFER_CONTRACT_SUCCESS,
        data: data,
    }
}

export const signJobOfferContract = (token, data) => {
    return {
        type: JOB_OFFER_CONTRACT_SIGN,
        token: token,
        data: data
    }
}

export const signJobOfferContractSuccess = (data) => {
    return {
        type: JOB_OFFER_CONTRACT_SIGN_SUCCESS,
        data: data,
    }
}

export const justOfferProposal = (token, data) => {
    return {
        type: JUST_JOB_OFFER_PROPOSAL,
        token: token,
        data: data
    }
}

export const updateContract = (token, data) => {
    return {
        type: JOB_OFFER_CONTRACT_PROPOSAL,
        token: token,
        data: data
    }
}

export const updateContractSuccess = (data) => {
    return {
        type: JOB_OFFER_CONTRACT_PROPOSAL_SUCCESS,
        data: data,
    }
}

export const endContract = (token, data) => {
    return {
        type: JOB_OFFER_CONTRACT_END,
        token: token,
        data: data
    }
}

export const endContractSuccess = (data) => {
    return {
        type: JOB_OFFER_CONTRACT_END_SUCCESS,
        data: data,
    }
}

export const interviewJoined = (token, data) => {
    return {
        type: JOB_OFFER_INTERVIEW_JOINED,
        token: token,
        data: data
    }
}

export const interviewJoinedSuccess = (data) => {
    return {
        type: JOB_OFFER_INTERVIEW_JOINED_SUCCESS,
        data: data,
    }
}

export const cancelOtherInterviews = (token, applicationId, jobOfferId) => {
    return {
        type: CANCEL_OTHER_INTERVIEWS,
        token: token,
        applicationId: applicationId,
        jobOfferId: jobOfferId
    }
}

export const cancelOtherInterviewsSuccess = (data) => {
    return {
        type: CANCEL_OTHER_INTERVIEWS_SUCCESS,
        data: data,
    }
}

export const resendJobOfferLinkRequest = (token, email, jobOfferId, intl) => ({
    type: RESEND_JOB_OFFER_LINK_REQUEST,
    token,
    email,
    jobOfferId,
    intl
});

export const resendJobOfferLinkSuccess = (message) => ({
    type: RESEND_JOB_OFFER_LINK_SUCCESS,
    message
});

export const resendJobOfferLinkFailure = (error) => ({
    type: RESEND_JOB_OFFER_LINK_FAILURE,
    error
});

export const showGuideCollaboration = () => {
    return {
        type: SHOW_GUIDE_COLLABORATION,
    }
}

export const fetchJobOfferPreviewStart = (id, token) => ({
    type: FETCH_JOB_OFFER_PREVIEW_START,
    payload: { id, token }
});

export const fetchJobOfferPreviewSuccess = (data) => ({
    type: FETCH_JOB_OFFER_PREVIEW_SUCCESS,
    payload: data
});

export const fetchJobOfferPreviewError = (error) => ({
    type: FETCH_JOB_OFFER_PREVIEW_ERROR,
    payload: error
});

export const searchJobOffers = (token, query) => {
    return {
        type: SEARCH_JOB_OFFERS,
        token: token,
        query: query
    }
}

export const searchJobOffersSuccess = (data) => {
    return {
        type: SEARCH_JOB_OFFERS_SUCCESS,
        data: data?.data,
    }
}

export const searchJobOffersCount = (token, query) => {
    return {
        type: SEARCH_JOB_OFFERS_COUNT,
        token: token,
        query: query
    }
}

export const searchJobOffersCountSuccess = (data) => {
    return {
        type: SEARCH_JOB_OFFERS_COUNT_SUCCESS,
        data: data?.data,
    }
}
